export interface IHeaderNavItem {
  label: string;
  route?: string;
  /** Paths that mark this link active. Defaults to [route] when route is set. */
  activeRoutes?: readonly string[];
  url?: string;
  newLine?: boolean;
  onClick?: () => void;
  className?: string;
}

export function isHeaderNavItemActive(pathname: string, item: IHeaderNavItem): boolean {
  if (!item.route) return false;
  return (item.activeRoutes ?? [item.route]).some(route => pathname === route || pathname.startsWith(`${route}/`));
}
